import { useTranslation } from "react-i18next";
import GoalImg from "assets/icons/goal.svg?react";
import NotaIcon from "assets/icons/nota.svg?react";
import styles from "./styles.module.scss";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Loading from "components/Loading";
import AuthLayout from "components/AuthLayout";
import userService from "api/userService";

const RemoveAccountModule = () => {
  const { t } = useTranslation();
  const { id, token } = useParams();
  const {
    mutate: confirm,
    isLoading,
    isError,
  } = userService.useRemoveAccountConfirm();

  useEffect(() => {
    confirm({
      userId: id,
      token: token,
    });
  }, []);

  if (isLoading) {
    return (
      <AuthLayout steps={[]} actualStep={0}>
        <>
          <Loading />
        </>
      </AuthLayout>
    );
  }

  if (isError) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.leftBar}>
          <div className={styles.logo}>
            <NotaIcon />
          </div>
          <div className={styles.text}>
            {t("activation.sidebarTagline")}
          </div>
          <div className={styles.img}>
            <GoalImg></GoalImg>
          </div>
          {/* <div className={styles.logout}>
            <HollowButton text="Wyloguj" onClick={() => {}}></HollowButton>
          </div> */}
        </div>
        <div className={styles.content}>
          <div className={styles.title}>{t("errors.accountDeletionFailed")}</div>
          <div className={styles.side}>
            {t("errors.accountAlreadyDeleted")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <AuthLayout steps={[]} actualStep={0}>
        <>
          <div className={styles.title}>{t("removeAccount.title")}</div>
          <div className={styles.side}>
            {t("removeAccount.deleted")}
          </div>
        </>
      </AuthLayout>
    </div>
  );
};

export default RemoveAccountModule;
